import { Component, OnInit } from '@angular/core';
import { DataService } from 'app/services/data.service';
import { XmppService } from "../../services/xmpp.service";
import { StateService } from '@uirouter/angular';
import { LogService } from "app/services/log.service";
import { Observable } from "rxjs/Rx";
import { FrontEndService } from 'app/services/front-end.service';

@Component({
    selector: 'app-project-users-tab',
    templateUrl: './project-users-tab.component.html',
    styleUrls: ['./project-users-tab.component.scss']
})
export class ProjectUsersTabComponent implements OnInit {

    selected_project = {};
    currentState: string;

    project_details_flag = true;
    loading = false;

    wait_timer = Observable.timer(0, 1000);
    wait_timer_subscription: any;

    project_status = "";
    project_active = true;
    project_owner = "";

    constructor(
        public dataService: DataService,
        public xmpp_service: XmppService,
        private stateService: StateService,
        private logService: LogService,
        public front_end_service: FrontEndService,
    ) { }

    ngOnInit() {
        this.wait_timer_subscription = this.wait_timer.subscribe(() => {
            if (this.project_details_flag) {
                this.wait_for_project_details("Local");
            }
        });
    }

    wait_for_project_details(event) {
        const temp = this.dataService.get_array_details(
            this.dataService.project_list,
            "fip_id",
            this.dataService.selected_project
        );

        if (temp !== undefined) {
            if (temp['title'] !== undefined) {
                this.project_details_flag = false;
                this.loading = false;
                this.selected_project = JSON.parse(JSON.stringify(temp));
                this.timeAgoFunction();
                this.logService.printLog("Selected Project", this.selected_project);

                this.wait_timer_subscription.unsubscribe();

                this.project_status = temp['status'];
                this.project_active = temp['isActive'];
                this.project_owner = temp['owner'].username;
            }
        }
    }

    /**
     * Open chat tab
     * @param userId
     */
    openChat(userId) {
        if (this.currentState !== "projectChats") {
            this.stateService.go('projectChats', { project_id: this.dataService.selected_project, user_id: userId })
        }
    }

    timeAgoFunction() {
        const assigneeType = ['patent_engineer', 'technical_expert', 'researcher', 'reviewer', 'legal_counsel', 'owner'];

        for (let j = 0; j < assigneeType.length; j++) {
            if (assigneeType[j] === 'owner') {
                if (this.selected_project.hasOwnProperty(assigneeType[j]) && this.selected_project[assigneeType[j]] !== null) {
                    this.selected_project[assigneeType[j]].last_login_diff = this.front_end_service.timeAgoConversion(this.selected_project[assigneeType[j]].last_login);
                } else {
                    this.selected_project[assigneeType[j]] = {};
                    this.selected_project[assigneeType[j]].last_login_diff = this.front_end_service.en_json_data['n_a'];
                }
            } else {
                for (let i = 0; i < this.selected_project[assigneeType[j]].length; i++) {
                    this.selected_project[assigneeType[j]][i].last_login_diff = this.front_end_service.timeAgoConversion(this.selected_project[assigneeType[j]][i].last_login);
                }
            }
        }
    }

    openProfile(id) {
        if (this.dataService.userProfileModuleEnabled) {
            this.stateService.go("profileDetails", {user_id: id});
        }
    }
}
